<div
  *ngIf="errorCount"
  id="mach-core-stays-widget-error"
  class="flex justify-center tablet:mb-[24px]"
>
  <idp-error-message
    [errorMessage]="'To continue, please correct the'"
    [cntError]="errorCount"
    [firstErroneousElement]="firstErrorElement"
    (firstInvalidFieldFocusEvent)="onFocusFirstInvalidField()"
  ></idp-error-message>
</div>
<form
  id="mach-core-stays-widget-form"
  [ngClass]="{
    'gap-[24px] laptop:gap-[8px] ultrawide:gap-[12px]':
      !viewSearchOptionExpanded,
    'gap-[8px]': viewSearchOptionExpanded
  }"
  class="flex flex-col items-center tablet:p-[2px] laptop:p-0 laptop:flex-row w-full"
  [formGroup]="staysWidgetForm"
  (ngSubmit)="formSubmit()"
>
  <div
    class="relative w-[343px] flex-shrink laptop:flex-1 tablet:w-[520px] laptop:w-[216.67px] ultrawide:w-[292px]"
    id="mach-core-stays-widget-location"
  >
    <idp-location
      (locationClicked)="locationClicked($event)"
      [content]="content.locationContent"
      [error]="destinationErrorMessage"
    ></idp-location>
    <div
      *ngIf="
        destinationErrorMessage ||
        datesErrorMessage ||
        tooFewPeopleErrorMessage ||
        tooFewRoomsErrorMessage ||
        maxDatesErrorMessage
      "
      class="laptop:h-[32px] mt-[8px]"
    >
      <div
        *ngIf="destinationErrorMessage"
        class="text-caption-medium text-alert"
      >
        {{ destinationErrorMessage }}
      </div>
    </div>
  </div>
  <div
    [ngClass]="{
      hidden: viewSearchOptionExpanded
    }"
    id="mach-core-stays-widget-view-options"
    class="laptop:hidden"
  >
    <idp-view-search-options
      (expand)="displayOptions()"
      [label]="content.labels.viewSearchOptions"
    ></idp-view-search-options>
  </div>
  <div
    [ngClass]="{
      hidden: !viewSearchOptionExpanded
    }"
    id="stays-widget__date-picker"
    class="flex-shrink laptop:block"
  >
    <button
      [id]="content.dropDownDateOption.triggerElementId"
      aria-expanded="true"
      class="flex h-[74px] w-[343px] cursor-pointer items-center justify-between rounded-02 border border-stroke-01 bg-surface-02 px-16 tablet:w-[520px] laptop:w-[194px] ultrawide:w-[212.67px]"
      [ngClass]="{
        'outline-2 outline-stroke-alert !outline':
          datesErrorMessage || maxDatesErrorMessage
      }"
      (click)="openDatePicker(); $event.preventDefault()"
    >
      <div class="flex flex-col items-start">
        <div class="flex items-center gap-8">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            class="text-icon-primary"
          >
            <path
              d="M13.165 1.68848C13.6922 1.6839 13.8291 2.15448 13.834 2.17188V3.14062C13.834 3.14062 15.6711 3.13597 16.2666 3.14062C16.8477 3.21239 16.875 3.68555 16.875 3.68555V14.6377C16.875 14.6377 16.9167 15.1499 15.9014 15.1826C13.3766 15.188 5.82211 15.1901 1.61133 15.1826C1.19801 15.1323 1.125 14.5771 1.125 14.5771V3.74609C1.125 3.74609 1.19012 3.15236 1.7334 3.14062C2.27219 3.12906 4.13174 3.14042 4.16504 3.14062V2.17188C4.16918 2.15813 4.32181 1.66566 4.83398 1.68848C5.34353 1.71144 5.49711 2.1545 5.50293 2.17188V3.14062H8.30078V2.17188C8.30483 2.15491 8.41982 1.69531 8.96973 1.68848C9.52083 1.68178 9.63518 2.15674 9.63867 2.17188V3.14062H12.4961V2.17188C12.4985 2.15639 12.5772 1.68787 13.165 1.68848ZM2.46387 13.8516H15.5381V7.49707H2.46387V13.8516ZM2.46387 6.16602H15.5381V4.47168H2.46387V6.16602Z"
              fill="currentColor"
            />
          </svg>
          <span
            id="range-date-display"
            class="!text-label-md-medium !text-heading leading-[1.375rem] tracking-[calc(var(--type-scale-4)*var(--letter-spacing-labels))]"
            style="color: var(--mds-text-heading)"
            attr.aria-label="{{ content.labels.findButton }} {{
              content.dropDownDateOption.title
            }}  date"
          >
            {{ content.dropDownDateOption.title }}
          </span>
        </div>
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        class="text-icon-primary transition-transform duration-200"
        [ngClass]="{ 'rotate-180': isDatePickerOpen }"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6 9L0.75 3H11.25L6 9Z"
          fill="currentColor"
        />
      </svg>
    </button>
    <div
      class="date-picker"
      [id]="content.dropDownDateOption.id"
      (click)="$event.stopPropagation(); $event.preventDefault()"
    ></div>
    <div
      *ngIf="
        destinationErrorMessage ||
        datesErrorMessage ||
        tooFewPeopleErrorMessage ||
        tooFewRoomsErrorMessage ||
        maxDatesErrorMessage
      "
      class="laptop:h-[32px] mt-[8px]"
    >
      <div *ngIf="datesErrorMessage" class="text-caption-medium text-alert">
        {{ datesErrorMessage }}
      </div>
      <div *ngIf="maxDatesErrorMessage" class="text-caption-medium text-alert">
        {{ maxDatesErrorMessage }}
      </div>
    </div>
  </div>
  <div
    [ngClass]="{
      hidden: !viewSearchOptionExpanded
    }"
    id="mach-core-stays-widget-traveler"
    class="flex-shrink laptop:block"
  >
    <div id="stays-widget__traveler-selector" class="w-full h-full relative">
      <button
        class="dropdown h-[74px] !border-[var(--mds-stroke-01)] w-[343px] tablet:w-[520px] laptop:w-[157.33px] laptop:text-ellipsis ultrawide:w-[212.67px]"
        [ngClass]="{
          'outline-2 outline-stroke-alert !outline': tooFewPeopleErrorMessage
        }"
        [id]="content.dropDownTravelerOption.id"
        (click)="$event.preventDefault()"
        style="border-color: var(--mds-stroke-01)"
      ></button>
    </div>
    <div
      *ngIf="
        destinationErrorMessage ||
        datesErrorMessage ||
        tooFewPeopleErrorMessage ||
        tooFewRoomsErrorMessage ||
        maxDatesErrorMessage
      "
      class="laptop:h-[32px] mt-[8px]"
    >
      <div
        *ngIf="tooFewPeopleErrorMessage"
        class="text-caption-medium text-alert"
      >
        {{ tooFewPeopleErrorMessage }}
      </div>
    </div>
  </div>
  <div
    [ngClass]="{
      hidden: !viewSearchOptionExpanded
    }"
    id="mach-core-stays-widget-room"
    class="flex-shrink laptop:block"
  >
    <div id="stays-widget__room-selector" class="h-full w-full relative">
      <button
        class="dropdown h-[74px] w-[343px] tablet:w-[520px] laptop:w-[157.33px] ultrawide:w-[212.67px]"
        [ngClass]="{
          'outline-2 outline-stroke-alert !outline': tooFewRoomsErrorMessage
        }"
        [id]="content.dropDownRoomOption.id"
        (click)="$event.preventDefault()"
        style="border-color: var(--mds-stroke-01)"
      ></button>
    </div>
    <div
      *ngIf="
        destinationErrorMessage ||
        datesErrorMessage ||
        tooFewPeopleErrorMessage ||
        tooFewRoomsErrorMessage ||
        maxDatesErrorMessage
      "
      class="laptop:h-[32px] mt-[8px]"
    >
      <div
        *ngIf="tooFewRoomsErrorMessage"
        class="text-caption-medium text-alert"
      >
        {{ tooFewRoomsErrorMessage }}
      </div>
    </div>
  </div>
  <div
    [ngClass]="{
      hidden: !viewSearchOptionExpanded
    }"
    id="mach-core-stays-widget-submit"
    class="flex-shrink-0 mt-[24px] laptop:mt-0 ultrawide:ml-[22px] laptop:block hidden"
  >
    <button
      #findButtonElement
      class="button button-primary button-lg text-label-md-semibold w-[343px] laptop:w-[132px] ultrawide:w-[154px] tablet:w-[520px] h-[64px] rounded-[6px] whitespace-nowrap"
      [attr.aria-label]="content.accessibility.findButtonAriaLabel"
      (click)="analyticsEvent.emit(findButtonElement)"
    >
      {{ content.labels.findButton }}
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_15646_212187)">
          <path
            d="M12 0V8.80078H10.3994V2.65625L1.13184 12.002L0 10.8604L9.18359 1.60059H3.19824V0H12Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_15646_212187">
            <rect width="12" height="12" fill="currentColor" />
          </clipPath>
        </defs>
      </svg>
    </button>
    <div
      *ngIf="
        destinationErrorMessage ||
        datesErrorMessage ||
        tooFewPeopleErrorMessage ||
        tooFewRoomsErrorMessage ||
        maxDatesErrorMessage
      "
      class="laptop:h-[32px] mt-[8px]"
    ></div>
  </div>
</form>
